// MainPage.tsx
import { BottomMenu } from '../components/BottomMenu/BottomMenu';
import { MainTop } from '../components/MainTop/MainTop';

function MainPage() {
return (
<>
<MainTop/>
<div style={{ padding: '20px' }}>
</div>
<BottomMenu/>
</>
);
}

export default MainPage;